import { useState, useEffect } from "react"
import { supabase } from "../lib/supabase"
import { Session } from "@supabase/supabase-js"

export const useAuth = () => {
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)
  const [hasAccess, setHasAccess] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) checkAccess(session.user.id)
      else setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) checkAccess(session.user.id)
      else { setHasAccess(false); setLoading(false) }
    })

    return () => subscription.unsubscribe()
  }, [])

  const checkAccess = async (userId: string) => {
    const { data } = await supabase
      .from("users")
      .select("has_access")
      .eq("id", userId)
      .single()

    setHasAccess(data?.has_access ?? false)
    setLoading(false)
  }

  return { session, loading, hasAccess }
}